(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["furclava-cart-header"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('furclava-announcement')) {
    customElements.define('furclava-announcement', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-enhanced')) return;
        const button = this.querySelector('.fc-cart-announcement__pause');
        if (!button) return;
        button.addEventListener('click', () => {
          const paused = button.getAttribute('aria-pressed') !== 'true';
          button.setAttribute('aria-pressed', String(paused));
          this.dataset.paused = String(paused);
        });
        this.setAttribute('data-enhanced', '');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stallsweep-product"] && !Shopify.designMode) return;
  try {
    function initializeStallSweepProducts(){
    document.querySelectorAll('[data-ss-product]').forEach(function(root){
      if(root.dataset.ready)return;root.dataset.ready='1';
      var form=root.querySelector('form'),variantInput=form.querySelector('[name=id]'),quantityInput=form.querySelector('[name=quantity]'),image=root.querySelector('.ss-product-image');
      var currency=root.dataset.currency||'USD';
      function setImage(src){if(!image||!src)return;image.removeAttribute('srcset');image.src=src;}
      function update(){
        var selected=variantInput.selectedOptions?variantInput.selectedOptions[0]:variantInput;
        var price=Number(selected.dataset.price),quantity=Math.max(1,Math.min(10,parseInt(quantityInput.value,10)||1));
        root.querySelector('[data-total]').textContent=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:currency}).format(price*quantity/100);
        if(selected.dataset.formattedPrice)root.querySelector('[data-unit-price]').textContent=selected.dataset.formattedPrice;
        var color=root.querySelector('[data-primary-color]');if(color)color.value=selected.dataset.color||'';
      }
      variantInput.addEventListener('change',function(){update();var selected=variantInput.selectedOptions&&variantInput.selectedOptions[0];if(selected)setImage(selected.dataset.imageUrl);});
      quantityInput.addEventListener('input',update);quantityInput.addEventListener('change',update);
      root.querySelectorAll('.ss-product-thumbnail').forEach(function(button){button.addEventListener('click',function(){setImage(button.dataset.imageUrl);root.querySelectorAll('.ss-product-thumbnail').forEach(function(b){b.setAttribute('aria-pressed',String(b===button));});});});
      update();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initializeStallSweepProducts);else initializeStallSweepProducts();
  document.addEventListener('shopify:section:load',initializeStallSweepProducts);
  } catch(e) { console.error(e); }
})();

})();
